import { formatSupplement } from "../../functions/money";
import { useEffect, useMemo, useState } from "react";

export const Combinations = ({ productData, variantId, setVariantId }) => {
  const mainGroup = useMemo(() => {
    const groups = productData?.optionsGroups || [];
    const explicitMain = groups.find((group) => group.isMainGroup);
    if (explicitMain) return explicitMain;
    // Match the API fallback: most options, retaining the first group on ties.
    return groups.reduce((largest, group) =>
      !largest || (group.options || []).length > (largest.options || []).length ? group : largest,
    null);
  }, [productData]);

  const mainOptions = useMemo(() => mainGroup?.options || [], [mainGroup]);

  const [selectedOptionId, setSelectedOptionId] = useState(() => {
    return mainOptions[0]?.optionId || "";
  });

  // Si cambia el producto/grupo/opciones, aseguramos un optionId válido seleccionado
  useEffect(() => {
    if (!mainOptions.length) {
      setSelectedOptionId("");
      return;
    }
    const exists = mainOptions.some((o) => o.optionId === selectedOptionId);
    if (!exists) setSelectedOptionId(mainOptions[0].optionId);
  }, [mainOptions, selectedOptionId]);

  const variantsToShow = useMemo(() => {
    const ordered = productData?.variantsOrdered || [];
    if (!selectedOptionId) return [];

    return ordered.filter((v) => v.optionId === selectedOptionId && Array.isArray(v.options) && v.options.length > 0);
  }, [productData, selectedOptionId]);

  if (!mainGroup || mainOptions.length === 0) return null;

  const visibleOptions = variant => {
    const options = variant.options || [];
    const secondary = options.filter(option => option.optionId !== selectedOptionId && option.name);
    // A size-only variant still needs a visible name, not just its supplement.
    return secondary.length ? secondary : options.filter(option => option.name);
  };

  const capitalize = (str = "") => str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <>
      <div>
        <h5>Combinaciones</h5>
      </div>

      {/* Desplegable: options del optionsGroup principal (isMainGroup:true) */}
      <div style={{ marginBottom: "8px" }}>
        <div className="details-name w-100 flex-gap" style={{ alignItems: "center" }}>
          <span style={{ marginRight: "8px", whiteSpace: "nowrap" }}>{capitalize(mainGroup.name)}</span>

          <select
            aria-label={`Seleccionar ${mainGroup.name || "opción principal"}`}
            value={selectedOptionId}
            onChange={(e) => { setSelectedOptionId(e.target.value); setVariantId(""); }}
            className="form-select"
            style={{ padding: "2px 6px", marginTop: "8px", border: "0", borderBottom: "1px lightgrey solid" }}
          >
            {mainOptions.map((opt) => (
              <option key={opt.optionId} value={opt.optionId}>
                {capitalize(opt.name)}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Variantes: variantsOrdered filtradas por optionId */}
      <div className="details-block-list">
        <div className="form w-100">
          {variantsToShow.map((variant, idx) => (
            <label className="flex-gap" key={`${variant.variantId}-ordered-${idx}`} style={{ alignItems: "center" }}>
              <div className="form w-100" style={{ gap: "1px", flexDirection: "row" }}>
                {visibleOptions(variant) // excluir la opción principal
                  .map((opt, i) =>
                    opt?.name ? (
                      <div key={`${variant.variantId}-${opt.optionId}-${i}`}>
                        <div className="item-info">
                          <div>
                            <span
                              style={{
                                padding: "0 8px",
                                borderRadius: "8px",
                              }}
                            >
                              {` ${capitalize(opt.name)}`}
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : null,
                  )}
              </div>

              <div className="flex-end" style={{ padding: "0 4px" }}>
                <div className="item-price">+{formatSupplement(variant.price, productData?.tax)}</div>

                <div className="item-check">
                  <input
                    aria-label={`Seleccionar combinación: ${(variant.options || []).map(option => option.name).filter(Boolean).join(", ")} (+${formatSupplement(variant.price, productData?.tax)})`}
                    type="radio"
                    name="variant"
                    className="item-checkbox"
                    onClick={() => setVariantId(variant.variantId)}
                    checked={variant.variantId === variantId}
                    onChange={() => null}
                  />
                </div>
              </div>
            </label>
          ))}

          {variantsToShow.length === 0 ? (
            <div style={{ padding: "6px 0", opacity: 0.7 }}>No hay variantes para esta opción.</div>
          ) : null}
        </div>
      </div>
    </>
  );
};
